<template>
    <div class="relatedCourse mb-5" ref="recommendContainer" v-if="currentShow">
        <div class="spinner-border text-primary" role="status" v-if="isLoading">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="relatedTitleBox" v-if="!isLoading">
            <h4 class="relatedTitle" v-text="title"></h4>
            <a href="course" class="more" title="">更多課程</a>
        </div>
        <div class="courseCarousel">
            <div class="owl-carousel" v-if="!isLoading" ref="carousel">
                <div class="box" v-for="item in recommends" :key="item.id">
                    <course-component
                        :course="item"
                        :course-link="`course/${item.slug}`"
                        :pic-url="item.Pics[0]?.url['w0h0']"
                        :spec-status="item.courseSpecStatus"
                        :favorite-added="item.favoriteAdded ? true : false"
                        :add-favorite-url="`course/favorite/${item.id}`"
                        :is-free="item.isFree"
                        :min-price="item.minPrice"
                        :max-price="item.maxPrice"
                        :wish-order-active="item.CourseField.wishOrderActive"
                        :target-sales-count="item.CourseField.wishOrderActive ? item.CourseField.wishOrderReachSales : item.targetSalesTime"
                        :current-sales-count="item.CourseField.wishOrderActive ? item.wish_order_user_count + item.CourseField.wishOrderBaseSalesCount : item.salesTime + item.baseSalesTime"
                        :limited-sales-start-date="item.CourseField.wishOrderActive ? item.CourseField.wishOrderFromDate : item.crowdfundingStartAt"
                        :limited-sales-end-date="item.CourseField.wishOrderActive ? item.CourseField.wishOrderToDate : item.crowdfundingEndAt"
                        :type-id-spec-id-key="item.typeIdSpecIdKey"
                        :rating="item.ratingsAvgRating"
                        :rating-count="item.ratingsCount"
                    ></course-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CourseComponent from 'Vue/Web/Shop/Course/CourseComponent.vue';

export default {
    name: 'RecommendCourseComponent',
    components: {
        CourseComponent,
    },
    props: {
        ids: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
        show: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false,
        },
        title: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '推薦課程',
        },
        url: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '/api/recommendCourse',
        },
    },
    data() {
        return {
            currentShow: false,
            isLoading: true,
            recommends: [],
        };
    },
    beforeMount() {
        this.currentShow = !!(this.ids || this.show);
    },
    mounted() {
        this.setupIntersectionObserver();
    },
    methods: {
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.2, // 當元素進入到 10% 的範圍時觸發
            };
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && this.currentShow) {
                        this.getResult();
                        observer.unobserve(this.$refs.recommendContainer); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);
            if (this.$refs.recommendContainer) {
                observer.observe(this.$refs.recommendContainer);
            }
        },
        initOwlCarousel() {
            $(this.$refs.carousel)
                .owlCarousel({
                    autoplay: false,
                    loop: false,
                    center: false,
                    navText: [],
                    nav: false,
                    dot: true,
                    margin: 10,
                    responsive: {
                        0: {
                            items: 1,
                        },
                        480: {
                            items: 2,
                        },
                        768: {
                            items: 3,
                        },
                        1366: {
                            items: 3,
                            margin: 20,
                        },
                    },
                });
        },
        formatDate(dateString) {
            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        },
        async getResult() {
            let response;
            try {
                response = await axios.get(`${this.url}/${this.ids}`);
                this.recommends = response.data.data;
                this.isLoading = false;
                if (this.recommends?.length > 0) {
                    // 等待 DOM 完全更新後再初始化 OwlCarousel
                    this.$nextTick(() => {
                        this.initOwlCarousel();
                    });
                } else {
                    this.currentShow = false;
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
<style scoped lang="scss">
$maincolor: #72ca4a;
$smallstandard:#555;
$bigstandard: #333;
$character: #666;
$bgcolor: #eee;
.spinner-border {
    margin: 0 50%;
}
.relatedCourse {
    width: 100%;
    .courseCarousel {
        margin: 0 -15px;
        width: 100%;
        @media (max-width: 1367px) {
            margin: 0 -7.5px;
        }
        .box {
            padding: 0 15px;
            padding: 0;
            @media (max-width: 1367px) {
                padding: 0 7.5px;
            }
        }
    }
    .relatedTitle {
        color: #333;
        font-size: 18px;
    }

    .relatedTitleBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2rem;
        .more {
            color: $smallstandard;
            position: relative;
            font-size: 12px;
            transition: 0.4s;
            padding: 0;
            &::after {
                content: '';
                position: absolute;
                width: 50%;
                height: 1px;
                bottom: 0px;
                background-color: #999;
                left: 0;
                transition: 0.3s linear;
            }
            &:hover {
                transition: 0.4s;
                color: $maincolor;
                &::after {
                    width: 100%;
                    background: $maincolor;
                    transition: 0.3s linear;
                }
            }
        }
    }
}
</style>
